module.exports = __webpack_public_path__ + "img/switch.6f35c54c.svg";